require('./index-labels.scss');

function setIndexLabels(carousel, currentIndex) {
    var INDEX_LABEL_CONTAINER_SELECTOR = '.carousel-index-label',
        PREV_INDEX_LABEL_CLASS = 'prev',
        NEXT_INDEX_LABEL_CLASS = 'next',
        INDEX_COUNTER_SELECTOR = '.index-count',
        TOTAL_COUNT_SELECTOR = '.total-count';

    var controls = carousel.siblings('.carousel-control').find(INDEX_LABEL_CONTAINER_SELECTOR),
        total = carousel.data('total'),
        currentSlideIndex = currentIndex + 1;


    controls.each(function(){
        var $control = $(this),
            $controlCounter = $control.find(INDEX_COUNTER_SELECTOR);

        $control.find(TOTAL_COUNT_SELECTOR).text(total);

        if ($control.hasClass(PREV_INDEX_LABEL_CLASS)){
            var previousSlideIndex = currentSlideIndex === 1? total : currentSlideIndex - 1;
            $controlCounter.text(previousSlideIndex);
        } else if ($control.hasClass(NEXT_INDEX_LABEL_CLASS)){
            var nextSlideIndex = currentSlideIndex === total? 1 : currentSlideIndex + 1;
            $controlCounter.text(nextSlideIndex);
        }
    });
}

function isLabelsEnabled(carousel) {
    return carousel.data('index-label') === true;
}

module.exports = {
    set: setIndexLabels,
    isEnabled: isLabelsEnabled
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/index-labels.js
// module id = 17
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17